import { defineFakeRoute } from 'vite-plugin-fake-server/client';
import { getSettingsState, updateSettingsState } from './settings-state';
import { isSettingsUpdate } from './settings-validation';
import { resultError, resultSuccess } from './utils';

// 系统设置与账号偏好独立；校验模块仅引用纯配置，确保 Node Fake 服务可加载。
export default defineFakeRoute([
  {
    url: '/platform/settings',
    method: 'get',
    response: () => resultSuccess(getSettingsState()),
  },
  {
    url: '/platform/settings',
    method: 'patch',
    response: ({ body }) => {
      if (!isSettingsUpdate(body)) return resultError('Invalid system settings', 422);
      if (body.expectedVersion !== getSettingsState().version)
        return resultError('System settings changed. Reload before saving.', 409);
      return resultSuccess(
        updateSettingsState({
          general: {
            siteTitle: body.general.siteTitle.trim(),
            shortTitle: body.general.shortTitle.trim(),
            logoDataUrl: body.general.logoDataUrl,
            browserTitle: body.general.browserTitle.trim(),
            copyright: body.general.copyright.trim(),
          },
          security: {
            loginAccess: body.security.loginAccess,
            maintenanceEnabled: body.security.maintenanceEnabled,
            maintenanceMessage: body.security.maintenanceMessage.trim(),
          },
          notifications: body.notifications,
        }),
      );
    },
  },
]);
